import { isTenant, isFullRemote, isPropertyManager } from '@/utils/roles';

export default class RedirectService {
  static isAllowToHomePage(router, to) {
    if (!isFullRemote() && !isPropertyManager() && isTenant() && to.path !== '/tenants/form') {
      router.push({ path: '/tenants/form' });
    }
  }
}
